// 数値整形（元帳らしい等幅表示を支える）。
export function fmtNum(x: number | null | undefined): string {
  if (x == null || Number.isNaN(x)) return '—';
  if (!Number.isFinite(x)) return '∞';
  const a = Math.abs(x);
  if (a >= 1000) return Math.round(x).toLocaleString('en-US');
  if (a >= 100) return x.toFixed(0);
  if (a >= 10) return x.toFixed(1);
  if (a >= 1) return x.toFixed(2);
  if (a === 0) return '0';
  if (a >= 0.01) return x.toFixed(3);
  return x.toFixed(4);
}

export function fmtMoney(x: number | null | undefined, unit: string): string {
  if (x == null || Number.isNaN(x)) return `— ${unit}`;
  return `${fmtNum(x)} ${unit}`;
}

export function pct(x: number | null | undefined, digits = 1): string {
  if (x == null || !Number.isFinite(x)) return '—';
  const v = x * 100;
  if (v > 0 && v < 0.1) return '<0.1%';
  return `${v >= 10 ? v.toFixed(0) : v.toFixed(digits)}%`;
}

/** 取得時刻 HH:MM（鮮度表示, §7）。 */
export function clockHHMM(ms: number): string {
  const d = new Date(ms);
  const h = String(d.getHours()).padStart(2, '0');
  const m = String(d.getMinutes()).padStart(2, '0');
  return `${h}:${m}`;
}
